import { createContext, useContext, type ReactNode } from 'react';
import type { UserDTO } from '@devrobot/shared';

const UserContext = createContext<UserDTO | null>(null);

export function UserProvider({ user, children }: { user: UserDTO; children: ReactNode }) {
  return <UserContext.Provider value={user}>{children}</UserContext.Provider>;
}

/** The signed-in user (available inside the authenticated layout). */
export function useUser(): UserDTO {
  const u = useContext(UserContext);
  if (!u) throw new Error('useUser() must be used inside the authenticated layout');
  return u;
}
